import { useState } from 'react';
import { useApp } from '../context/AppContext';
import { 
  LayoutDashboard, Package, FolderOpen, Users, FileText, ShoppingCart, 
  Mail, LogOut, Menu, X, ChevronRight, Building 
} from 'lucide-react';

const adminNavItems = [
  { key: 'admin-dashboard', label: 'Dashboard', icon: <LayoutDashboard size={18} /> },
  { key: 'admin-products', label: 'Produits', icon: <Package size={18} /> },
  { key: 'admin-categories', label: 'Catégories', icon: <FolderOpen size={18} /> },
  { key: 'admin-users', label: 'Utilisateurs', icon: <Users size={18} /> },
  { key: 'admin-reseller-applications', label: 'Demandes revendeurs', icon: <Building size={18} /> },
  { key: 'admin-orders', label: 'Commandes', icon: <ShoppingCart size={18} /> },
  { key: 'admin-quotes', label: 'Devis', icon: <FileText size={18} /> },
  { key: 'admin-contact', label: 'Messages', icon: <Mail size={18} /> },
];

export default function AdminLayout({ children }: { children: React.ReactNode }) {
  const { lang, page, setPage, currentUser, logout } = useApp();
  const [sidebarOpen, setSidebarOpen] = useState(true);

  const isActive = (key: string) => page === key;

  const handleLogout = async () => {
    await logout();
    setPage('home');
  };

  return (
    <div className="min-h-screen bg-gray-100 flex">
      {/* Sidebar */}
      <aside className={`${sidebarOpen ? 'w-64' : 'w-16'} bg-gray-900 text-white flex flex-col transition-all duration-300 fixed h-full z-40`}>
        {/* Logo */}
        <div className="h-16 flex items-center justify-between px-4 border-b border-gray-800">
          {sidebarOpen && (
            <button
              onClick={() => setPage('home')}
              className="flex items-center gap-2"
            >
              <img src="/logo-1762256791_-_Modifie.png" alt="LODISS" className="h-8 w-auto" />
            </button>
          )}
          <button
            onClick={() => setSidebarOpen(!sidebarOpen)}
            className="p-1 hover:bg-gray-800 rounded"
          >
            {sidebarOpen ? <X size={18} /> : <Menu size={18} />}
          </button>
        </div>

        {/* Admin Info */}
        {sidebarOpen && (
          <div className="px-4 py-3 border-b border-gray-800">
            <p className="text-xs text-gray-400 uppercase">Admin</p>
            <p className="font-medium truncate">{currentUser?.full_name}</p>
          </div>
        )}

        {/* Navigation */}
        <nav className="flex-1 py-4 overflow-y-auto">
          <ul className="space-y-1 px-2">
            {adminNavItems.map(item => (
              <li key={item.key}>
                <button
                  onClick={() => setPage(item.key as any)}
                  className={`w-full flex items-center gap-3 px-3 py-2.5 rounded-lg transition-colors ${
                    isActive(item.key)
                      ? 'bg-lodiss-red text-white'
                      : 'text-gray-300 hover:bg-gray-800 hover:text-white'
                  }`}
                  title={!sidebarOpen ? item.label : undefined}
                >
                  {item.icon}
                  {sidebarOpen && <span>{item.label}</span>}
                </button>
              </li>
            ))}
          </ul>
        </nav>

        {/* Logout */}
        <div className="p-2 border-t border-gray-800">
          <button
            onClick={handleLogout}
            className="w-full flex items-center gap-3 px-3 py-2.5 rounded-lg text-gray-300 hover:bg-gray-800 hover:text-white transition-colors"
            title={!sidebarOpen ? 'Déconnexion' : undefined}
          >
            <LogOut size={18} />
            {sidebarOpen && <span>Déconnexion</span>}
          </button>
        </div>
      </aside>

      {/* Main Content */}
      <main className={`flex-1 ${sidebarOpen ? 'ml-64' : 'ml-16'} transition-all duration-300`}>
        <div className="p-6">
          {children}
        </div>
      </main>
    </div>
  );
}
